<script setup lang="ts">
import {
  computed,
} from "vue";

const props = defineProps<{
  content: string;
}>();

const bodyContent = computed(() => {
  const match = props.content.match(/<body>([\s\S]*)<\/body>/i);
  return match ? match[1] : props.content;
});
</script>

<template>
  <div
    class="agreement-container animate-fade-in"
    v-html="bodyContent"
  />
</template>

<style scoped>
@reference "../assets/css/main.css";

.agreement-container {
  min-height: 200px;
}

:deep(ul li) {
  list-style: disc !important;
}

:deep(ol li) {
  list-style: decimal !important;
}

:deep(*) {
  box-sizing: border-box;
}

:deep(.document) {
  @apply bg-gray-50/50 dark:bg-gray-800/50;
  @apply text-gray-600 dark:text-gray-200;
  box-shadow: 0 14px 40px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

:deep(.hero) {
  padding: 24px;
  background: linear-gradient(135deg, #1e3a8a, #2563eb);
  color: white;
}

:deep(.hero h1) {
  margin: 0 0 10px;
  font-size: 34px;
  line-height: 1.2;
}

:deep(.hero p) {
  margin: 0;
  opacity: 0.92;
}

:deep(.content) {
  padding: 0 24px;
}

:deep(section) {
  padding: 24px 0;
  @apply border-b border-gray-200 dark:border-gray-700;
}

:deep(section:last-child) {
  @apply border-none;
}

:deep(h2) {
  margin: 0 0 16px;
  @apply text-blue-500 dark:text-blue-400;
  font-size: 23px;
  line-height: 1.35;
}

:deep(h3) {
  margin: 22px 0 10px;
  color: #111827;
  font-size: 18px;
}

:deep(p:not(:last-child)) {
  margin: 0 0 14px;
}

:deep(ul) {
  margin: 10px 0 0;
  padding-left: 24px;
}

:deep(li) {
  margin: 6px 0;
}

:deep(.info-box) {
  @apply bg-gray-200/50 dark:bg-gray-700/50;
  @apply border border-gray-200 dark:border-gray-700;
  border-radius: 4px;
  padding: 18px 20px;
  margin: 16px 0;
}

:deep(.checkbox-list) {
  list-style: none;
  padding-left: 0;
}

:deep(.checkbox-list li) {
  padding: 8px 0;
}

:deep(a) {
  @apply text-blue-500 dark:text-blue-400;
  text-decoration: none;
  font-weight: 600;
}

:deep(a:hover) {
  text-decoration: underline;
}

:deep(.footer) {
  @apply bg-gray-200/50 dark:bg-gray-700/50;
  @apply border-t border-gray-200 dark:border-gray-700;
  padding: 24px;
  @apply text-gray-600 dark:text-gray-200;
  font-size: 14px;
}

.animate-fade-in {
  animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
